import React from 'react';
import { Box, Paper, Typography, Chip, Grid } from '@mui/material';

const formatNumber = (value, digits = 2) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '-';
  }
  if (typeof value === 'number') {
    return value.toFixed(digits);
  }
  return value;
};

const ChipList = ({ label, values }) => {
  if (!values || values.length === 0) {
    return null;
  }
  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {values.map((value) => (
          <Chip key={value} label={value} size="small" variant="outlined" />
        ))}
      </Box>
    </Box>
  );
};

const StatTile = ({ label, value }) => (
  <Box
    sx={{
      p: 1,
      backgroundColor: 'grey.50',
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'grey.200',
      minWidth: 'fit-content',
    }}
  >
    <Typography variant="caption" color="text.secondary">
      {label}: {formatNumber(value)}
    </Typography>
  </Box>
);

const FarcasterUserCard = ({ hit }) => {
  const { _source } = hit;
  const userId = _source.user_id || hit._id || '-';
  const followingCount = Array.isArray(_source.following_user_ids)
    ? _source.following_user_ids.length
    : 0;

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Farcaster User {userId}
        </Typography>
        <Chip
          label={hit._score != null ? hit._score.toFixed(2) : '-'}
          size="small"
          variant="outlined"
          color="primary"
        />
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
        Updated: {_source.updated_at || '-'}
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Grid container spacing={1}>
          <Grid item>
            <StatTile label="Events/Day" value={_source.events_per_day} />
          </Grid>
          <Grid item>
            <StatTile label="Spam" value={_source.score_spam} />
          </Grid>
          <Grid item>
            <StatTile label="Not OK" value={_source.score_not_ok} />
          </Grid>
          <Grid item>
            <StatTile label="Following" value={followingCount} />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mt: 2 }}>
        <ChipList label="Primary Labels" values={_source.primary_labels} />
        <ChipList label="Secondary Labels" values={_source.secondary_labels} />
        <ChipList label="Primary Clusters" values={_source.primary_clusters} />
        <ChipList label="Secondary Clusters" values={_source.secondary_clusters} />
      </Box>
    </Paper>
  );
};

export default FarcasterUserCard;
